import { SxProps, Theme, Typography, TypographyProps } from '@mui/material';
import { FC } from 'react';

interface Props {
  className?: string;
  sx?: SxProps<Theme>;
  fontSize?: number | string;
  variant?: TypographyProps['variant'];
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const QcsTypography: FC<Props> = ({
  className,
  sx,
  fontSize,
  variant,
  align,
  children,
  style
}) => {
  return (
    <Typography
      className={className}
      sx={sx}
      fontSize={fontSize}
      variant={variant}
      align={align}
      style={style}
    >
      {children}
    </Typography>
  );
};
